export default [
    {
        cardId: 3030004,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【僕と猫】",
        Blooming: false,
        image: "Cards/3030004/Card_3030004_1_b.png",
    },
    {
        cardId: 4150009,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【極彩色で笑いたい】",
        Blooming: true,
        image: "Cards/4150009/Card_4150009_2_b.png",
    },
    {
        cardId: 4150008,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【フィルムいっぱいの思い出を】",
        Blooming: false,
        image: "Cards/4150008/Card_4150008_1_b.png",
    },
    {
        cardId: 4010015,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【AiRBLUE X'mas!】",
        Blooming: false,
        image: "Cards/4010015/Card_4010015_1_b.png",
    },
    {
        cardId: 4100005,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【Forever Friends】",
        Blooming: true,
        image: "Cards/4100005/Card_4100005_2_b.png",
    },
    {
        cardId: 3140007,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【君、死にたもうことなかれ】",
        Blooming: false,
        image: "Cards/3140007/Card_3140007_1_b.png",
    },
    {
        cardId: 4110010,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【孤独ノスヽメ】",
        Blooming: true,
        image: "Cards/4110010/Card_4110010_2_b.png",
    },
    {
        cardId: 3110004,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【dig down メモリーズ】",
        Blooming: false,
        image: "Cards/3110004/Card_3110004_1_b.png",
    },
    {
        cardId: 3070013,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【秋空のスイッチ】",
        Blooming: false,
        image: "Cards/3070013/Card_3070013_1_b.png",
    },
    {
        cardId: 4150008,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【フィルムいっぱいの思い出を】",
        Blooming: true,
        image: "Cards/4150008/Card_4150008_2_b.png",
    },
    {
        cardId: 3130011,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【エリスちゃんは大忙し】",
        Blooming: true,
        image: "Cards/3130011/Card_3130011_2_b.png",
    },
    {
        cardId: 4110013,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【RING! RING! RING!】",
        Blooming: false,
        image: "Cards/4110013/Card_4110013_1_b.png",
    },
    {
        cardId: 4150005,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【Forever Friends】",
        Blooming: false,
        image: "Cards/4150005/Card_4150005_1_b.png",
    },
    {
        cardId: 3060006,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【プリンセスは大忙し】",
        Blooming: true,
        image: "Cards/3060006/Card_3060006_2_b.png",
    },
    {
        cardId: 4030014,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【いただきのほし】",
        Blooming: false,
        image: "Cards/4030014/Card_4030014_1_b.png",
    },
    {
        cardId: 4160016,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【Usual Cases】",
        Blooming: true,
        image: "Cards/4160016/Card_4160016_2_b.png",
    },
    {
        cardId: 3030015,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【はんにんはヤツ】",
        Blooming: true,
        image: "Cards/3030015/Card_3030015_2_b.png",
    },
    {
        cardId: 3010007,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【秋晴れ乙女】",
        Blooming: true,
        image: "Cards/3010007/Card_3010007_2_b.png",
    },
    {
        cardId: 3060006,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【プリンセスは大忙し】",
        Blooming: false,
        image: "Cards/3060006/Card_3060006_1_b.png",
    },
    {
        cardId: 3130004,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【賞味期限にご注意を】",
        Blooming: true,
        image: "Cards/3130004/Card_3130004_2_b.png",
    },
    {
        cardId: 3050006,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【唇よ、熱くキミを語れ！】",
        Blooming: false,
        image: "Cards/3050006/Card_3050006_1_b.png",
    },
    {
        cardId: 4090007,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【ゆっくり消える虹を見て】",
        Blooming: false,
        image: "Cards/4090007/Card_4090007_1_b.png",
    },
    {
        cardId: 4030012,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【なつかげすずし】",
        Blooming: true,
        image: "Cards/4030012/Card_4030012_2_b.png",
    },
    {
        cardId: 3100004,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【Don’t be a stranger.】",
        Blooming: true,
        image: "Cards/3100004/Card_3100004_2_b.png",
    },
    {
        cardId: 4020007,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【シタマチ・ファミリア】",
        Blooming: false,
        image: "Cards/4020007/Card_4020007_1_b.png",
    },
    {
        cardId: 4050011,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【僕らの声優力研究所】",
        Blooming: true,
        image: "Cards/4050011/Card_4050011_2_b.png",
    },
    {
        cardId: 4080010,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【UP！】",
        Blooming: true,
        image: "Cards/4080010/Card_4080010_2_b.png",
    },
    {
        cardId: 4100011,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【End of twilight】",
        Blooming: false,
        image: "Cards/4100011/Card_4100011_1_b.png",
    },
    {
        cardId: 4040018,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【タイドアフター】",
        Blooming: false,
        image: "Cards/4040018/Card_4040018_1_b.png",
    },
    {
        cardId: 3150012,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【おためしマーケット】",
        Blooming: false,
        image: "Cards/3150012/Card_3150012_1_b.png",
    },
    {
        cardId: 3030004,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【僕と猫】",
        Blooming: true,
        image: "Cards/3030004/Card_3030004_2_b.png",
    },
    {
        cardId: 3130015,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【超展望ネスト】",
        Blooming: false,
        image: "Cards/3130015/Card_3130015_1_b.png",
    },
    {
        cardId: 3090006,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【幸せをルバートで】",
        Blooming: false,
        image: "Cards/3090006/Card_3090006_1_b.png",
    },
    {
        cardId: 4120009,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【パウダーシュガーの降る頃に】",
        Blooming: true,
        image: "Cards/4120009/Card_4120009_2_b.png",
    },
    {
        cardId: 4070011,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【雨に唄えば】",
        Blooming: true,
        image: "Cards/4070011/Card_4070011_2_b.png",
    },
    {
        cardId: 4030014,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【いただきのほし】",
        Blooming: true,
        image: "Cards/4030014/Card_4030014_2_b.png",
    },
    {
        cardId: 4140016,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【プルス・ウルトラ】",
        Blooming: false,
        image: "Cards/4140016/Card_4140016_1_b.png",
    },
    {
        cardId: 3130015,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【超展望ネスト】",
        Blooming: true,
        image: "Cards/3130015/Card_3130015_2_b.png",
    },
    {
        cardId: 4110009,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【DAYS and the DAY】",
        Blooming: false,
        image: "Cards/4110009/Card_4110009_1_b.png",
    },
    {
        cardId: 4010012,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【エヴァーグリーン】",
        Blooming: false,
        image: "Cards/4010012/Card_4010012_1_b.png",
    },
    {
        cardId: 9150015,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【はなみ発見！】",
        Blooming: false,
        image: "Cards/9150015/Card_9150015_1_b.png",
    },
    {
        cardId: 4070012,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【ウォーターキャンディ】",
        Blooming: true,
        image: "Cards/4070012/Card_4070012_2_b.png",
    },
    {
        cardId: 9060015,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【プリンス・チャーミング】",
        Blooming: false,
        image: "Cards/9060015/Card_9060015_1_b.png",
    },
    {
        cardId: 3100008,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【Reunion. 街角にて】",
        Blooming: true,
        image: "Cards/3100008/Card_3100008_2_b.png",
    },
    {
        cardId: 3070004,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【ひとりでできるもん！】",
        Blooming: true,
        image: "Cards/3070004/Card_3070004_2_b.png",
    },
    {
        cardId: 3110006,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【ハッピーハンティング】",
        Blooming: true,
        image: "Cards/3110006/Card_3110006_2_b.png",
    },
    {
        cardId: 3040006,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【Let's go around】",
        Blooming: true,
        image: "Cards/3040006/Card_3040006_2_b.png",
    },
    {
        cardId: 3140006,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【獣の操者】",
        Blooming: true,
        image: "Cards/3140006/Card_3140006_2_b.png",
    },
    {
        cardId: 3100014,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【Fancy A Brew?】",
        Blooming: true,
        image: "Cards/3100014/Card_3100014_2_b.png",
    },
    {
        cardId: 3140009,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【掌のカラフル】",
        Blooming: true,
        image: "Cards/3140009/Card_3140009_2_b.png",
    },
    {
        cardId: 3150006,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【しあわせのかたち】",
        Blooming: true,
        image: "Cards/3150006/Card_3150006_2_b.png",
    },
    {
        cardId: 4090011,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【雲がちぎれる時を】",
        Blooming: false,
        image: "Cards/4090011/Card_4090011_1_b.png",
    },
    {
        cardId: 3100008,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【Reunion. 街角にて】",
        Blooming: false,
        image: "Cards/3100008/Card_3100008_1_b.png",
    },
    {
        cardId: 4060016,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【魔法をかけて】",
        Blooming: true,
        image: "Cards/4060016/Card_4060016_2_b.png",
    },
    {
        cardId: 4090005,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【Forever Friends】",
        Blooming: true,
        image: "Cards/4090005/Card_4090005_2_b.png",
    },
    {
        cardId: 4120010,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【タイムコールが聴こえる】",
        Blooming: true,
        image: "Cards/4120010/Card_4120010_2_b.png",
    },
    {
        cardId: 3070004,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【ひとりでできるもん！】",
        Blooming: false,
        image: "Cards/3070004/Card_3070004_1_b.png",
    },
    {
        cardId: 4080005,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【Forever Friends】",
        Blooming: false,
        image: "Cards/4080005/Card_4080005_1_b.png",
    },
    {
        cardId: 3020006,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【そっと背中を押して】",
        Blooming: false,
        image: "Cards/3020006/Card_3020006_1_b.png",
    },
    {
        cardId: 3020008,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【フォーチュンランナー】",
        Blooming: false,
        image: "Cards/3020008/Card_3020008_1_b.png",
    },
    {
        cardId: 4080012,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【ユー・ガット・エール】",
        Blooming: true,
        image: "Cards/4080012/Card_4080012_2_b.png",
    },
    {
        cardId: 4120010,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【タイムコールが聴こえる】",
        Blooming: false,
        image: "Cards/4120010/Card_4120010_1_b.png",
    },
    {
        cardId: 4160012,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【Red Alert】",
        Blooming: false,
        image: "Cards/4160012/Card_4160012_1_b.png",
    },
    {
        cardId: 3100006,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【the shine leads...】",
        Blooming: false,
        image: "Cards/3100006/Card_3100006_1_b.png",
    },
    {
        cardId: 4080017,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【Feast and Family】",
        Blooming: false,
        image: "Cards/4080017/Card_4080017_1_b.png",
    },
    {
        cardId: 4060008,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【小さな当たり前と大きな幸せ】",
        Blooming: true,
        image: "Cards/4060008/Card_4060008_2_b.png",
    },
    {
        cardId: 4010010,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【桜の花舞う教室で】",
        Blooming: true,
        image: "Cards/4010010/Card_4010010_2_b.png",
    },
    {
        cardId: 3130008,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【黒祭ドミネーション】",
        Blooming: true,
        image: "Cards/3130008/Card_3130008_2_b.png",
    },
    {
        cardId: 3010017,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【夜風が香る】",
        Blooming: false,
        image: "Cards/3010017/Card_3010017_1_b.png",
    },
    {
        cardId: 4140005,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【Forever Friends】",
        Blooming: false,
        image: "Cards/4140005/Card_4140005_1_b.png",
    },
    {
        cardId: 4040010,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【スタンドバイミー】",
        Blooming: false,
        image: "Cards/4040010/Card_4040010_1_b.png",
    },
    {
        cardId: 4070009,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【春風トラベリング】",
        Blooming: false,
        image: "Cards/4070009/Card_4070009_1_b.png",
    },
    {
        cardId: 3130008,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【黒祭ドミネーション】",
        Blooming: false,
        image: "Cards/3130008/Card_3130008_1_b.png",
    },
    {
        cardId: 4050011,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【僕らの声優力研究所】",
        Blooming: false,
        image: "Cards/4050011/Card_4050011_1_b.png",
    },
    {
        cardId: 4020011,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【ベイビー・クロケット】",
        Blooming: true,
        image: "Cards/4020011/Card_4020011_2_b.png",
    },
    {
        cardId: 4090014,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【opus 66】",
        Blooming: true,
        image: "Cards/4090014/Card_4090014_2_b.png",
    },
    {
        cardId: 3130011,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【エリスちゃんは大忙し】",
        Blooming: false,
        image: "Cards/3130011/Card_3130011_1_b.png",
    },
    {
        cardId: 4050009,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【疾走れ！自転の勇者ママチャリオン】",
        Blooming: true,
        image: "Cards/4050009/Card_4050009_2_b.png",
    },
    {
        cardId: 4150011,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【夏の日のイリュージョン】",
        Blooming: true,
        image: "Cards/4150011/Card_4150011_2_b.png",
    },
    {
        cardId: 4140012,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【在りし日の詩】",
        Blooming: false,
        image: "Cards/4140012/Card_4140012_1_b.png",
    },
    {
        cardId: 3080004,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【楽しみの求道者】",
        Blooming: false,
        image: "Cards/3080004/Card_3080004_1_b.png",
    },
    {
        cardId: 4090009,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【スイート・セレナーデ】",
        Blooming: false,
        image: "Cards/4090009/Card_4090009_1_b.png",
    },
    {
        cardId: 3010017,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【夜風が香る】",
        Blooming: true,
        image: "Cards/3010017/Card_3010017_2_b.png",
    },
    {
        cardId: 4070009,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【春風トラベリング】",
        Blooming: true,
        image: "Cards/4070009/Card_4070009_2_b.png",
    },
    {
        cardId: 3160004,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【オブジェクト・アンディファインド】",
        Blooming: true,
        image: "Cards/3160004/Card_3160004_2_b.png",
    },
    {
        cardId: 3120015,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【せきららにダブルス】",
        Blooming: false,
        image: "Cards/3120015/Card_3120015_1_b.png",
    },
    {
        cardId: 4050012,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【元気のオーラ・バトル】",
        Blooming: true,
        image: "Cards/4050012/Card_4050012_2_b.png",
    },
    {
        cardId: 4150014,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【ぱーふぇくとわーるど】",
        Blooming: true,
        image: "Cards/4150014/Card_4150014_2_b.png",
    },
    {
        cardId: 4150014,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【ぱーふぇくとわーるど】",
        Blooming: false,
        image: "Cards/4150014/Card_4150014_1_b.png",
    },
    {
        cardId: 3140009,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【掌のカラフル】",
        Blooming: false,
        image: "Cards/3140009/Card_3140009_1_b.png",
    },
    {
        cardId: 4160011,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【バレット・タイム】",
        Blooming: true,
        image: "Cards/4160011/Card_4160011_2_b.png",
    },
    {
        cardId: 4070007,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【導きのロストラビット】",
        Blooming: true,
        image: "Cards/4070007/Card_4070007_2_b.png",
    },
    {
        cardId: 3050008,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【鋼のウィンターブレイカー】",
        Blooming: false,
        image: "Cards/3050008/Card_3050008_1_b.png",
    },
    {
        cardId: 4090007,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【ゆっくり消える虹を見て】",
        Blooming: true,
        image: "Cards/4090007/Card_4090007_2_b.png",
    },
    {
        cardId: 3140004,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【聡里の宝物庫】",
        Blooming: true,
        image: "Cards/3140004/Card_3140004_2_b.png",
    },
    {
        cardId: 4110016,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【You saw my soul】",
        Blooming: false,
        image: "Cards/4110016/Card_4110016_1_b.png",
    },
    {
        cardId: 4070011,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【雨に唄えば】",
        Blooming: false,
        image: "Cards/4070011/Card_4070011_1_b.png",
    },
    {
        cardId: 4130007,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【Reach For The World!】",
        Blooming: false,
        image: "Cards/4130007/Card_4130007_1_b.png",
    },
    {
        cardId: 3040006,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【Let's go around】",
        Blooming: false,
        image: "Cards/3040006/Card_3040006_1_b.png",
    },
    {
        cardId: 4130009,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【カストールの安息日】",
        Blooming: false,
        image: "Cards/4130009/Card_4130009_1_b.png",
    },
    {
        cardId: 3010006,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【クロスロード・サインポスト】",
        Blooming: false,
        image: "Cards/3010006/Card_3010006_1_b.png",
    },
    {
        cardId: 4110009,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【DAYS and the DAY】",
        Blooming: true,
        image: "Cards/4110009/Card_4110009_2_b.png",
    },
    {
        cardId: 4140012,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【在りし日の詩】",
        Blooming: true,
        image: "Cards/4140012/Card_4140012_2_b.png",
    },
    {
        cardId: 4030005,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【Forever Friends】",
        Blooming: true,
        image: "Cards/4030005/Card_4030005_2_b.png",
    },
    {
        cardId: 4150010,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【ビン詰めの花畑】",
        Blooming: false,
        image: "Cards/4150010/Card_4150010_1_b.png",
    },
    {
        cardId: 4010014,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【ハーモニー・ダイナー】",
        Blooming: true,
        image: "Cards/4010014/Card_4010014_2_b.png",
    },
    {
        cardId: 3060007,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【舞踏会へようこそ】",
        Blooming: true,
        image: "Cards/3060007/Card_3060007_2_b.png",
    },
    {
        cardId: 4040007,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【フラワートレック】",
        Blooming: true,
        image: "Cards/4040007/Card_4040007_2_b.png",
    },
    {
        cardId: 3100004,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【Don’t be a stranger.】",
        Blooming: false,
        image: "Cards/3100004/Card_3100004_1_b.png",
    },
    {
        cardId: 4080010,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【UP！】",
        Blooming: false,
        image: "Cards/4080010/Card_4080010_1_b.png",
    },
    {
        cardId: 4160007,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【ヴィジョン・キツネ】",
        Blooming: true,
        image: "Cards/4160007/Card_4160007_2_b.png",
    },
    {
        cardId: 4140017,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【ゲルトルート】",
        Blooming: false,
        image: "Cards/4140017/Card_4140017_1_b.png",
    },
    {
        cardId: 4120016,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【帰れない？帰らない？】",
        Blooming: true,
        image: "Cards/4120016/Card_4120016_2_b.png",
    },
    {
        cardId: 4140005,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【Forever Friends】",
        Blooming: true,
        image: "Cards/4140005/Card_4140005_2_b.png",
    },
    {
        cardId: 4090016,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【何度も言わせて】",
        Blooming: true,
        image: "Cards/4090016/Card_4090016_2_b.png",
    },
    {
        cardId: 4140010,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【ウェーニーウィーディーウィーキー】",
        Blooming: false,
        image: "Cards/4140010/Card_4140010_1_b.png",
    },
    {
        cardId: 3090015,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【ウインナワルツ】",
        Blooming: false,
        image: "Cards/3090015/Card_3090015_1_b.png",
    },
    {
        cardId: 3070010,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【コネクト】",
        Blooming: false,
        image: "Cards/3070010/Card_3070010_1_b.png",
    },
    {
        cardId: 4010010,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【桜の花舞う教室で】",
        Blooming: false,
        image: "Cards/4010010/Card_4010010_1_b.png",
    },
    {
        cardId: 4040016,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【わたしのアリーナ！】",
        Blooming: true,
        image: "Cards/4040016/Card_4040016_2_b.png",
    },
    {
        cardId: 3130006,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【客星のきざし】",
        Blooming: true,
        image: "Cards/3130006/Card_3130006_2_b.png",
    },
    {
        cardId: 4020010,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【シロクロ・コミット】",
        Blooming: true,
        image: "Cards/4020010/Card_4020010_2_b.png",
    },
    {
        cardId: 4140011,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【雲の向こうは青空】",
        Blooming: false,
        image: "Cards/4140011/Card_4140011_1_b.png",
    },
    {
        cardId: 3160013,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【オー・ド・ヴィー】",
        Blooming: false,
        image: "Cards/3160013/Card_3160013_1_b.png",
    },
    {
        cardId: 9030013,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【みちへのいざない】",
        Blooming: false,
        image: "Cards/9030013/Card_9030013_1_b.png",
    },
    {
        cardId: 3100009,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【Can you see what I see】",
        Blooming: false,
        image: "Cards/3100009/Card_3100009_1_b.png",
    },
    {
        cardId: 3120004,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【幸運を抱きしめて】",
        Blooming: true,
        image: "Cards/3120004/Card_3120004_2_b.png",
    },
    {
        cardId: 3040009,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【クリアスノウ】",
        Blooming: true,
        image: "Cards/3040009/Card_3040009_2_b.png",
    },
    {
        cardId: 4010013,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【廻る日の１ページ】",
        Blooming: false,
        image: "Cards/4010013/Card_4010013_1_b.png",
    },
    {
        cardId: 4140017,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【ゲルトルート】",
        Blooming: true,
        image: "Cards/4140017/Card_4140017_2_b.png",
    },
    {
        cardId: 3120015,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【せきららにダブルス】",
        Blooming: true,
        image: "Cards/3120015/Card_3120015_2_b.png",
    },
    {
        cardId: 3010004,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【ステップ・バイ・ステップ】",
        Blooming: false,
        image: "Cards/3010004/Card_3010004_1_b.png",
    },
    {
        cardId: 4120012,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【オフショアの乙女】",
        Blooming: false,
        image: "Cards/4120012/Card_4120012_1_b.png",
    },
    {
        cardId: 4090013,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【真夏の夜の夢】",
        Blooming: true,
        image: "Cards/4090013/Card_4090013_2_b.png",
    },
    {
        cardId: 4080005,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【Forever Friends】",
        Blooming: true,
        image: "Cards/4080005/Card_4080005_2_b.png",
    },
    {
        cardId: 3140014,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【薔薇と黙示録をあなたに】",
        Blooming: true,
        image: "Cards/3140014/Card_3140014_2_b.png",
    },
    {
        cardId: 3120011,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【君が選ばれた日に】",
        Blooming: true,
        image: "Cards/3120011/Card_3120011_2_b.png",
    },
    {
        cardId: 4070017,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【未来永遠のともだち】",
        Blooming: false,
        image: "Cards/4070017/Card_4070017_1_b.png",
    },
    {
        cardId: 4040018,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【タイドアフター】",
        Blooming: true,
        image: "Cards/4040018/Card_4040018_2_b.png",
    },
    {
        cardId: 3050010,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【爆誕！TENDO-MkⅡ】",
        Blooming: false,
        image: "Cards/3050010/Card_3050010_1_b.png",
    },
    {
        cardId: 4080017,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【Feast and Family】",
        Blooming: true,
        image: "Cards/4080017/Card_4080017_2_b.png",
    },
    {
        cardId: 4070016,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【KAZAHANA】",
        Blooming: false,
        image: "Cards/4070016/Card_4070016_1_b.png",
    },
    {
        cardId: 4090014,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【opus 66】",
        Blooming: false,
        image: "Cards/4090014/Card_4090014_1_b.png",
    },
    {
        cardId: 3080016,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【Terms of Fortune】",
        Blooming: false,
        image: "Cards/3080016/Card_3080016_1_b.png",
    },
    {
        cardId: 3120004,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【幸運を抱きしめて】",
        Blooming: false,
        image: "Cards/3120004/Card_3120004_1_b.png",
    },
    {
        cardId: 3110007,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【古書ツナグ古都、photo】",
        Blooming: true,
        image: "Cards/3110007/Card_3110007_2_b.png",
    },
    {
        cardId: 4060013,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【オーバー・ザ・シー】",
        Blooming: true,
        image: "Cards/4060013/Card_4060013_2_b.png",
    },
    {
        cardId: 3130004,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【賞味期限にご注意を】",
        Blooming: false,
        image: "Cards/3130004/Card_3130004_1_b.png",
    },
    {
        cardId: 3090004,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【フェアリー・オン・ステージ】",
        Blooming: true,
        image: "Cards/3090004/Card_3090004_2_b.png",
    },
    {
        cardId: 4140016,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【プルス・ウルトラ】",
        Blooming: true,
        image: "Cards/4140016/Card_4140016_2_b.png",
    },
    {
        cardId: 4150011,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【夏の日のイリュージョン】",
        Blooming: false,
        image: "Cards/4150011/Card_4150011_1_b.png",
    },
    {
        cardId: 4100007,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【in other words】",
        Blooming: true,
        image: "Cards/4100007/Card_4100007_2_b.png",
    },
    {
        cardId: 4060014,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【ハッピー・キングダムズ】",
        Blooming: false,
        image: "Cards/4060014/Card_4060014_1_b.png",
    },
    {
        cardId: 4060008,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【小さな当たり前と大きな幸せ】",
        Blooming: false,
        image: "Cards/4060008/Card_4060008_1_b.png",
    },
    {
        cardId: 4010018,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【届け君へ】",
        Blooming: true,
        image: "Cards/4010018/Card_4010018_2_b.png",
    },
    {
        cardId: 4120014,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【エンドオブサマーを見送って】",
        Blooming: false,
        image: "Cards/4120014/Card_4120014_1_b.png",
    },
    {
        cardId: 4020013,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【ゴールデンアワー】",
        Blooming: true,
        image: "Cards/4020013/Card_4020013_2_b.png",
    },
    {
        cardId: 3080004,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【楽しみの求道者】",
        Blooming: true,
        image: "Cards/3080004/Card_3080004_2_b.png",
    },
    {
        cardId: 4140008,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【勝利の栄光を君に】",
        Blooming: true,
        image: "Cards/4140008/Card_4140008_2_b.png",
    },
    {
        cardId: 4050016,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【ままならない戦場】",
        Blooming: false,
        image: "Cards/4050016/Card_4050016_1_b.png",
    },
    {
        cardId: 3040004,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【チェイス！】",
        Blooming: false,
        image: "Cards/3040004/Card_3040004_1_b.png",
    },
    {
        cardId: 4080014,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【harvest ＆ pup】",
        Blooming: true,
        image: "Cards/4080014/Card_4080014_2_b.png",
    },
    {
        cardId: 3040011,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【ウィッシュムーン】",
        Blooming: false,
        image: "Cards/3040011/Card_3040011_1_b.png",
    },
    {
        cardId: 3030006,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【視線の奥に】",
        Blooming: false,
        image: "Cards/3030006/Card_3030006_1_b.png",
    },
    {
        cardId: 4140013,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【ステラ・ハント】",
        Blooming: false,
        image: "Cards/4140013/Card_4140013_1_b.png",
    },
    {
        cardId: 3020008,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【フォーチュンランナー】",
        Blooming: true,
        image: "Cards/3020008/Card_3020008_2_b.png",
    },
    {
        cardId: 4110008,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【ユメ・ウツツ・Unconscious】",
        Blooming: false,
        image: "Cards/4110008/Card_4110008_1_b.png",
    },
    {
        cardId: 3080011,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【リトルプレジデント】",
        Blooming: false,
        image: "Cards/3080011/Card_3080011_1_b.png",
    },
    {
        cardId: 3020004,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【カミズ・ホリデイ】",
        Blooming: true,
        image: "Cards/3020004/Card_3020004_2_b.png",
    },
    {
        cardId: 3060011,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【この手に恵みを】",
        Blooming: true,
        image: "Cards/3060011/Card_3060011_2_b.png",
    },
    {
        cardId: 4070016,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【KAZAHANA】",
        Blooming: true,
        image: "Cards/4070016/Card_4070016_2_b.png",
    },
    {
        cardId: 4160012,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【Red Alert】",
        Blooming: true,
        image: "Cards/4160012/Card_4160012_2_b.png",
    },
    {
        cardId: 4160015,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【アクターズ・ギルド】",
        Blooming: true,
        image: "Cards/4160015/Card_4160015_2_b.png",
    },
    {
        cardId: 4150013,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【ゆうやけ小路】",
        Blooming: true,
        image: "Cards/4150013/Card_4150013_2_b.png",
    },
    {
        cardId: 9140015,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【木枯らし古書店】",
        Blooming: false,
        image: "Cards/9140015/Card_9140015_1_b.png",
    },
    {
        cardId: 4030010,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【ぬれねこにひき】",
        Blooming: false,
        image: "Cards/4030010/Card_4030010_1_b.png",
    },
    {
        cardId: 4040014,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【way of life】",
        Blooming: true,
        image: "Cards/4040014/Card_4040014_2_b.png",
    },
    {
        cardId: 3060004,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【シスター・シスター】",
        Blooming: false,
        image: "Cards/3060004/Card_3060004_1_b.png",
    },
    {
        cardId: 3070006,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【未来の主人公？】",
        Blooming: false,
        image: "Cards/3070006/Card_3070006_1_b.png",
    },
    {
        cardId: 4010014,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【ハーモニー・ダイナー】",
        Blooming: false,
        image: "Cards/4010014/Card_4010014_1_b.png",
    },
    {
        cardId: 3160009,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【ウィスパリング・ワン】",
        Blooming: false,
        image: "Cards/3160009/Card_3160009_1_b.png",
    },
    {
        cardId: 3160004,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【オブジェクト・アンディファインド】",
        Blooming: false,
        image: "Cards/3160004/Card_3160004_1_b.png",
    },
    {
        cardId: 4040005,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【Forever Friends】",
        Blooming: true,
        image: "Cards/4040005/Card_4040005_2_b.png",
    },
    {
        cardId: 4110013,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【RING! RING! RING!】",
        Blooming: true,
        image: "Cards/4110013/Card_4110013_2_b.png",
    },
    {
        cardId: 4160014,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【PORTAL】",
        Blooming: true,
        image: "Cards/4160014/Card_4160014_2_b.png",
    },
    {
        cardId: 4050014,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【天童重工進出ス！】",
        Blooming: true,
        image: "Cards/4050014/Card_4050014_2_b.png",
    },
    {
        cardId: 4040012,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【女王に捧げる薬指】",
        Blooming: true,
        image: "Cards/4040012/Card_4040012_2_b.png",
    },
    {
        cardId: 4070005,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【Forever Friends】",
        Blooming: true,
        image: "Cards/4070005/Card_4070005_2_b.png",
    },
    {
        cardId: 4020010,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【シロクロ・コミット】",
        Blooming: false,
        image: "Cards/4020010/Card_4020010_1_b.png",
    },
    {
        cardId: 3090006,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【幸せをルバートで】",
        Blooming: true,
        image: "Cards/3090006/Card_3090006_2_b.png",
    },
    {
        cardId: 3080011,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【リトルプレジデント】",
        Blooming: true,
        image: "Cards/3080011/Card_3080011_2_b.png",
    },
    {
        cardId: 3050004,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【永久機関オルタネーター】",
        Blooming: true,
        image: "Cards/3050004/Card_3050004_2_b.png",
    },
    {
        cardId: 4100013,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【above the promise】",
        Blooming: false,
        image: "Cards/4100013/Card_4100013_1_b.png",
    },
    {
        cardId: 3080018,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【The Back-up Plan】",
        Blooming: true,
        image: "Cards/3080018/Card_3080018_2_b.png",
    },
    {
        cardId: 4020013,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【ゴールデンアワー】",
        Blooming: false,
        image: "Cards/4020013/Card_4020013_1_b.png",
    },
    {
        cardId: 3050013,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【てめぇら全員召し上がれ！】",
        Blooming: true,
        image: "Cards/3050013/Card_3050013_2_b.png",
    },
    {
        cardId: 3110007,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【古書ツナグ古都、photo】",
        Blooming: false,
        image: "Cards/3110007/Card_3110007_1_b.png",
    },
    {
        cardId: 3040004,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【チェイス！】",
        Blooming: true,
        image: "Cards/3040004/Card_3040004_2_b.png",
    },
    {
        cardId: 4090009,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【スイート・セレナーデ】",
        Blooming: true,
        image: "Cards/4090009/Card_4090009_2_b.png",
    },
    {
        cardId: 4070012,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【ウォーターキャンディ】",
        Blooming: false,
        image: "Cards/4070012/Card_4070012_1_b.png",
    },
    {
        cardId: 3010008,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【グロウアップ・デイズ】",
        Blooming: false,
        image: "Cards/3010008/Card_3010008_1_b.png",
    },
    {
        cardId: 4120005,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【Forever Friends】",
        Blooming: false,
        image: "Cards/4120005/Card_4120005_1_b.png",
    },
    {
        cardId: 4010009,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【束の間のロンググッドバイ】",
        Blooming: true,
        image: "Cards/4010009/Card_4010009_2_b.png",
    },
    {
        cardId: 4130007,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【Reach For The World!】",
        Blooming: true,
        image: "Cards/4130007/Card_4130007_2_b.png",
    },
    {
        cardId: 4010015,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【AiRBLUE X'mas!】",
        Blooming: true,
        image: "Cards/4010015/Card_4010015_2_b.png",
    },
    {
        cardId: 4050007,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【三兵衛、秋の感謝フェア】",
        Blooming: true,
        image: "Cards/4050007/Card_4050007_2_b.png",
    },
    {
        cardId: 4100005,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【Forever Friends】",
        Blooming: false,
        image: "Cards/4100005/Card_4100005_1_b.png",
    },
    {
        cardId: 3160009,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【ウィスパリング・ワン】",
        Blooming: true,
        image: "Cards/3160009/Card_3160009_2_b.png",
    },
    {
        cardId: 3150006,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【しあわせのかたち】",
        Blooming: false,
        image: "Cards/3150006/Card_3150006_1_b.png",
    },
    {
        cardId: 4080015,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【パッシング・トーキョー】",
        Blooming: true,
        image: "Cards/4080015/Card_4080015_2_b.png",
    },
    {
        cardId: 3120011,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【君が選ばれた日に】",
        Blooming: false,
        image: "Cards/3120011/Card_3120011_1_b.png",
    },
    {
        cardId: 4160016,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【Usual Cases】",
        Blooming: false,
        image: "Cards/4160016/Card_4160016_1_b.png",
    },
    {
        cardId: 4130014,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【星辰揃いし夜の囁き】",
        Blooming: true,
        image: "Cards/4130014/Card_4130014_2_b.png",
    },
    {
        cardId: 3040009,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【クリアスノウ】",
        Blooming: false,
        image: "Cards/3040009/Card_3040009_1_b.png",
    },
    {
        cardId: 4030007,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【ひとりこのへやで】",
        Blooming: false,
        image: "Cards/4030007/Card_4030007_1_b.png",
    },
    {
        cardId: 4120017,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【青空バイクに恋してる】",
        Blooming: false,
        image: "Cards/4120017/Card_4120017_1_b.png",
    },
    {
        cardId: 4160005,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【Forever Friends】",
        Blooming: true,
        image: "Cards/4160005/Card_4160005_2_b.png",
    },
    {
        cardId: 4130013,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【誰ソ彼のオーダー】",
        Blooming: true,
        image: "Cards/4130013/Card_4130013_2_b.png",
    },
    {
        cardId: 4010005,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【Forever Friends】",
        Blooming: true,
        image: "Cards/4010005/Card_4010005_2_b.png",
    },
    {
        cardId: 4140010,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【ウェーニーウィーディーウィーキー】",
        Blooming: true,
        image: "Cards/4140010/Card_4140010_2_b.png",
    },
    {
        cardId: 4120017,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【青空バイクに恋してる】",
        Blooming: true,
        image: "Cards/4120017/Card_4120017_2_b.png",
    },
    {
        cardId: 4050014,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【天童重工進出ス！】",
        Blooming: false,
        image: "Cards/4050014/Card_4050014_1_b.png",
    },
    {
        cardId: 4070005,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【Forever Friends】",
        Blooming: false,
        image: "Cards/4070005/Card_4070005_1_b.png",
    },
    {
        cardId: 4010012,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【エヴァーグリーン】",
        Blooming: true,
        image: "Cards/4010012/Card_4010012_2_b.png",
    },
    {
        cardId: 4060009,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【笑顔で空を灯して】",
        Blooming: false,
        image: "Cards/4060009/Card_4060009_1_b.png",
    },
    {
        cardId: 3020009,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【シンケン・トライブ】",
        Blooming: true,
        image: "Cards/3020009/Card_3020009_2_b.png",
    },
    {
        cardId: 3030011,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【ことのはさらさら】",
        Blooming: false,
        image: "Cards/3030011/Card_3030011_1_b.png",
    },
    {
        cardId: 3120006,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【天使は肉体労働がお好き】",
        Blooming: true,
        image: "Cards/3120006/Card_3120006_2_b.png",
    },
    {
        cardId: 3150004,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【走れ凛音】",
        Blooming: false,
        image: "Cards/3150004/Card_3150004_1_b.png",
    },
    {
        cardId: 4050012,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【元気のオーラ・バトル】",
        Blooming: false,
        image: "Cards/4050012/Card_4050012_1_b.png",
    },
    {
        cardId: 3120008,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【縁起色レイクフェア】",
        Blooming: false,
        image: "Cards/3120008/Card_3120008_1_b.png",
    },
    {
        cardId: 4090011,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【雲がちぎれる時を】",
        Blooming: true,
        image: "Cards/4090011/Card_4090011_2_b.png",
    },
    {
        cardId: 3060011,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【この手に恵みを】",
        Blooming: false,
        image: "Cards/3060011/Card_3060011_1_b.png",
    },
    {
        cardId: 4150009,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【極彩色で笑いたい】",
        Blooming: false,
        image: "Cards/4150009/Card_4150009_1_b.png",
    },
    {
        cardId: 3110004,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【dig down メモリーズ】",
        Blooming: true,
        image: "Cards/3110004/Card_3110004_2_b.png",
    },
    {
        cardId: 3100006,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【the shine leads...】",
        Blooming: true,
        image: "Cards/3100006/Card_3100006_2_b.png",
    },
    {
        cardId: 4130005,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【Forever Friends】",
        Blooming: true,
        image: "Cards/4130005/Card_4130005_2_b.png",
    },
    {
        cardId: 3100012,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【penguin avenue】",
        Blooming: true,
        image: "Cards/3100012/Card_3100012_2_b.png",
    },
    {
        cardId: 3020004,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【カミズ・ホリデイ】",
        Blooming: false,
        image: "Cards/3020004/Card_3020004_1_b.png",
    },
    {
        cardId: 3160006,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【ダーク・ルーム】",
        Blooming: false,
        image: "Cards/3160006/Card_3160006_1_b.png",
    },
    {
        cardId: 4110016,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【You saw my soul】",
        Blooming: true,
        image: "Cards/4110016/Card_4110016_2_b.png",
    },
    {
        cardId: 4120014,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【エンドオブサマーを見送って】",
        Blooming: true,
        image: "Cards/4120014/Card_4120014_2_b.png",
    },
    {
        cardId: 4030012,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【なつかげすずし】",
        Blooming: false,
        image: "Cards/4030012/Card_4030012_1_b.png",
    },
    {
        cardId: 4090010,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【Secret Garden】",
        Blooming: false,
        image: "Cards/4090010/Card_4090010_1_b.png",
    },
    {
        cardId: 3050013,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【てめぇら全員召し上がれ！】",
        Blooming: false,
        image: "Cards/3050013/Card_3050013_1_b.png",
    },
    {
        cardId: 4130010,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【炎獄式ビターエンド】",
        Blooming: false,
        image: "Cards/4130010/Card_4130010_1_b.png",
    },
    {
        cardId: 3030006,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【視線の奥に】",
        Blooming: true,
        image: "Cards/3030006/Card_3030006_2_b.png",
    },
    {
        cardId: 9010016,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【SEE YOU EVERYDAY】",
        Blooming: false,
        image: "Cards/9010016/Card_9010016_1_b.png",
    },
    {
        cardId: 4060012,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【部屋の中の晴々】",
        Blooming: false,
        image: "Cards/4060012/Card_4060012_1_b.png",
    },
    {
        cardId: 3010011,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【リトル・バイ・リトル】",
        Blooming: true,
        image: "Cards/3010011/Card_3010011_2_b.png",
    },
    {
        cardId: 4060014,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【ハッピー・キングダムズ】",
        Blooming: true,
        image: "Cards/4060014/Card_4060014_2_b.png",
    },
    {
        cardId: 4150013,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【ゆうやけ小路】",
        Blooming: false,
        image: "Cards/4150013/Card_4150013_1_b.png",
    },
    {
        cardId: 4130013,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【誰ソ彼のオーダー】",
        Blooming: false,
        image: "Cards/4130013/Card_4130013_1_b.png",
    },
    {
        cardId: 3010011,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【リトル・バイ・リトル】",
        Blooming: false,
        image: "Cards/3010011/Card_3010011_1_b.png",
    },
    {
        cardId: 4160015,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【アクターズ・ギルド】",
        Blooming: false,
        image: "Cards/4160015/Card_4160015_1_b.png",
    },
    {
        cardId: 4040014,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【way of life】",
        Blooming: false,
        image: "Cards/4040014/Card_4040014_1_b.png",
    },
    {
        cardId: 3030011,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【ことのはさらさら】",
        Blooming: true,
        image: "Cards/3030011/Card_3030011_2_b.png",
    },
    {
        cardId: 3140004,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【聡里の宝物庫】",
        Blooming: false,
        image: "Cards/3140004/Card_3140004_1_b.png",
    },
    {
        cardId: 9040017,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【Target of Subject】",
        Blooming: false,
        image: "Cards/9040017/Card_9040017_1_b.png",
    },
    {
        cardId: 4130010,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【炎獄式ビターエンド】",
        Blooming: true,
        image: "Cards/4130010/Card_4130010_2_b.png",
    },
    {
        cardId: 4060016,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【魔法をかけて】",
        Blooming: false,
        image: "Cards/4060016/Card_4060016_1_b.png",
    },
    {
        cardId: 4160010,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【リンケージ・マイナー】",
        Blooming: false,
        image: "Cards/4160010/Card_4160010_1_b.png",
    },
    {
        cardId: 9110015,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【NITELITE】",
        Blooming: false,
        image: "Cards/9110015/Card_9110015_1_b.png",
    },
    {
        cardId: 4010005,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【Forever Friends】",
        Blooming: false,
        image: "Cards/4010005/Card_4010005_1_b.png",
    },
    {
        cardId: 3150012,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【おためしマーケット】",
        Blooming: true,
        image: "Cards/3150012/Card_3150012_2_b.png",
    },
    {
        cardId: 4110012,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【way of life, where to go?】",
        Blooming: false,
        image: "Cards/4110012/Card_4110012_1_b.png",
    },
    {
        cardId: 3050008,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【鋼のウィンターブレイカー】",
        Blooming: true,
        image: "Cards/3050008/Card_3050008_2_b.png",
    },
    {
        cardId: 3080006,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【ネオリアリズム！】",
        Blooming: true,
        image: "Cards/3080006/Card_3080006_2_b.png",
    },
    {
        cardId: 3080008,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【ルーキーアイスガール】",
        Blooming: true,
        image: "Cards/3080008/Card_3080008_2_b.png",
    },
    {
        cardId: 4110008,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【ユメ・ウツツ・Unconscious】",
        Blooming: true,
        image: "Cards/4110008/Card_4110008_2_b.png",
    },
    {
        cardId: 3030004,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【僕と猫】",
        Blooming: false,
        image: "Cards/3030004/Card_3030004_1_b.png",
    },
    {
        cardId: 4050005,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【Forever Friends】",
        Blooming: true,
        image: "Cards/4050005/Card_4050005_2_b.png",
    },
    {
        cardId: 4050007,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【三兵衛、秋の感謝フェア】",
        Blooming: false,
        image: "Cards/4050007/Card_4050007_1_b.png",
    },
    {
        cardId: 4040007,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【フラワートレック】",
        Blooming: false,
        image: "Cards/4040007/Card_4040007_1_b.png",
    },
    {
        cardId: 4020007,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【シタマチ・ファミリア】",
        Blooming: true,
        image: "Cards/4020007/Card_4020007_2_b.png",
    },
    {
        cardId: 4070007,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【導きのロストラビット】",
        Blooming: false,
        image: "Cards/4070007/Card_4070007_1_b.png",
    },
    {
        cardId: 4030008,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【わたしにできること】",
        Blooming: true,
        image: "Cards/4030008/Card_4030008_2_b.png",
    },
    {
        cardId: 4110014,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【DELIGHT & DAYLIGHT】",
        Blooming: true,
        image: "Cards/4110014/Card_4110014_2_b.png",
    },
    {
        cardId: 4090013,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【真夏の夜の夢】",
        Blooming: false,
        image: "Cards/4090013/Card_4090013_1_b.png",
    },
    {
        cardId: 4050016,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【ままならない戦場】",
        Blooming: true,
        image: "Cards/4050016/Card_4050016_2_b.png",
    },
    {
        cardId: 4130012,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【冷酷なる悪魔のエクスキューション】",
        Blooming: false,
        image: "Cards/4130012/Card_4130012_1_b.png",
    },
    {
        cardId: 3080006,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【ネオリアリズム！】",
        Blooming: false,
        image: "Cards/3080006/Card_3080006_1_b.png",
    },
    {
        cardId: 4140013,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【ステラ・ハント】",
        Blooming: true,
        image: "Cards/4140013/Card_4140013_2_b.png",
    },
    {
        cardId: 3020012,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【キャンパス・エッヂ】",
        Blooming: false,
        image: "Cards/3020012/Card_3020012_1_b.png",
    },
    {
        cardId: 3110006,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【ハッピーハンティング】",
        Blooming: false,
        image: "Cards/3110006/Card_3110006_1_b.png",
    },
    {
        cardId: 3070013,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【秋空のスイッチ】",
        Blooming: true,
        image: "Cards/3070013/Card_3070013_2_b.png",
    },
    {
        cardId: 4070017,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【未来永遠のともだち】",
        Blooming: true,
        image: "Cards/4070017/Card_4070017_2_b.png",
    },
    {
        cardId: 4050005,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【Forever Friends】",
        Blooming: false,
        image: "Cards/4050005/Card_4050005_1_b.png",
    },
    {
        cardId: 4160014,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【PORTAL】",
        Blooming: false,
        image: "Cards/4160014/Card_4160014_1_b.png",
    },
    {
        cardId: 3150007,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【エイジ・オブ・ディスカバリー】",
        Blooming: true,
        image: "Cards/3150007/Card_3150007_2_b.png",
    },
    {
        cardId: 3050010,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【爆誕！TENDO-MkⅡ】",
        Blooming: true,
        image: "Cards/3050010/Card_3050010_2_b.png",
    },
    {
        cardId: 3070008,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【ワンデイ・スター】",
        Blooming: false,
        image: "Cards/3070008/Card_3070008_1_b.png",
    },
    {
        cardId: 3130006,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【客星のきざし】",
        Blooming: false,
        image: "Cards/3130006/Card_3130006_1_b.png",
    },
    {
        cardId: 4150005,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【Forever Friends】",
        Blooming: true,
        image: "Cards/4150005/Card_4150005_2_b.png",
    },
    {
        cardId: 4110012,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【way of life, where to go?】",
        Blooming: true,
        image: "Cards/4110012/Card_4110012_2_b.png",
    },
    {
        cardId: 3010004,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【ステップ・バイ・ステップ】",
        Blooming: true,
        image: "Cards/3010004/Card_3010004_2_b.png",
    },
    {
        cardId: 4060005,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【Forever Friends】",
        Blooming: false,
        image: "Cards/4060005/Card_4060005_1_b.png",
    },
    {
        cardId: 4100010,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【back on top】",
        Blooming: false,
        image: "Cards/4100010/Card_4100010_1_b.png",
    },
    {
        cardId: 4090010,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【Secret Garden】",
        Blooming: true,
        image: "Cards/4090010/Card_4090010_2_b.png",
    },
    {
        cardId: 3090008,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【Dreams will come true】",
        Blooming: false,
        image: "Cards/3090008/Card_3090008_1_b.png",
    },
    {
        cardId: 4060010,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【今日は明日の思い出】",
        Blooming: true,
        image: "Cards/4060010/Card_4060010_2_b.png",
    },
    {
        cardId: 4140008,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【勝利の栄光を君に】",
        Blooming: false,
        image: "Cards/4140008/Card_4140008_1_b.png",
    },
    {
        cardId: 4040016,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【わたしのアリーナ！】",
        Blooming: false,
        image: "Cards/4040016/Card_4040016_1_b.png",
    },
    {
        cardId: 3100014,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【Fancy A Brew?】",
        Blooming: false,
        image: "Cards/3100014/Card_3100014_1_b.png",
    },
    {
        cardId: 4020014,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【ライトマイファイア】",
        Blooming: false,
        image: "Cards/4020014/Card_4020014_1_b.png",
    },
    {
        cardId: 3020006,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【そっと背中を押して】",
        Blooming: true,
        image: "Cards/3020006/Card_3020006_2_b.png",
    },
    {
        cardId: 3070008,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【ワンデイ・スター】",
        Blooming: true,
        image: "Cards/3070008/Card_3070008_2_b.png",
    },
    {
        cardId: 4020005,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【Forever Friends】",
        Blooming: true,
        image: "Cards/4020005/Card_4020005_2_b.png",
    },
    {
        cardId: 4020005,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【Forever Friends】",
        Blooming: false,
        image: "Cards/4020005/Card_4020005_1_b.png",
    },
    {
        cardId: 4040008,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【Never Knows Best】",
        Blooming: true,
        image: "Cards/4040008/Card_4040008_2_b.png",
    },
    {
        cardId: 4040010,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【スタンドバイミー】",
        Blooming: true,
        image: "Cards/4040010/Card_4040010_2_b.png",
    },
    {
        cardId: 3100009,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【Can you see what I see】",
        Blooming: true,
        image: "Cards/3100009/Card_3100009_2_b.png",
    },
    {
        cardId: 4100010,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【back on top】",
        Blooming: true,
        image: "Cards/4100010/Card_4100010_2_b.png",
    },
    {
        cardId: 3090008,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【Dreams will come true】",
        Blooming: true,
        image: "Cards/3090008/Card_3090008_2_b.png",
    },
    {
        cardId: 3140006,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【獣の操者】",
        Blooming: false,
        image: "Cards/3140006/Card_3140006_1_b.png",
    },
    {
        cardId: 4040008,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【Never Knows Best】",
        Blooming: false,
        image: "Cards/4040008/Card_4040008_1_b.png",
    },
    {
        cardId: 4130014,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【星辰揃いし夜の囁き】",
        Blooming: false,
        image: "Cards/4130014/Card_4130014_1_b.png",
    },
    {
        cardId: 4010018,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【届け君へ】",
        Blooming: false,
        image: "Cards/4010018/Card_4010018_1_b.png",
    },
    {
        cardId: 4120005,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【Forever Friends】",
        Blooming: true,
        image: "Cards/4120005/Card_4120005_2_b.png",
    },
    {
        cardId: 4160008,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【Only two twin primes】",
        Blooming: false,
        image: "Cards/4160008/Card_4160008_1_b.png",
    },
    {
        cardId: 4030007,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【ひとりこのへやで】",
        Blooming: true,
        image: "Cards/4030007/Card_4030007_2_b.png",
    },
    {
        cardId: 4080009,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【ランチタイム・アップデート】",
        Blooming: false,
        image: "Cards/4080009/Card_4080009_1_b.png",
    },
    {
        cardId: 3120006,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【天使は肉体労働がお好き】",
        Blooming: false,
        image: "Cards/3120006/Card_3120006_1_b.png",
    },
    {
        cardId: 4130009,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【カストールの安息日】",
        Blooming: true,
        image: "Cards/4130009/Card_4130009_2_b.png",
    },
    {
        cardId: 3060007,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【舞踏会へようこそ】",
        Blooming: false,
        image: "Cards/3060007/Card_3060007_1_b.png",
    },
    {
        cardId: 4030008,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【わたしにできること】",
        Blooming: false,
        image: "Cards/4030008/Card_4030008_1_b.png",
    },
    {
        cardId: 3010008,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【グロウアップ・デイズ】",
        Blooming: true,
        image: "Cards/3010008/Card_3010008_2_b.png",
    },
    {
        cardId: 4140011,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【雲の向こうは青空】",
        Blooming: true,
        image: "Cards/4140011/Card_4140011_2_b.png",
    },
    {
        cardId: 4120016,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【帰れない？帰らない？】",
        Blooming: false,
        image: "Cards/4120016/Card_4120016_1_b.png",
    },
    {
        cardId: 3070006,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【未来の主人公？】",
        Blooming: true,
        image: "Cards/3070006/Card_3070006_2_b.png",
    },
    {
        cardId: 4160007,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【ヴィジョン・キツネ】",
        Blooming: false,
        image: "Cards/4160007/Card_4160007_1_b.png",
    },
    {
        cardId: 3070014,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【スウィート・ワン】",
        Blooming: false,
        image: "Cards/3070014/Card_3070014_1_b.png",
    },
    {
        cardId: 3030009,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【かぜのまにまに】",
        Blooming: false,
        image: "Cards/3030009/Card_3030009_1_b.png",
    },
    {
        cardId: 4080009,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【ランチタイム・アップデート】",
        Blooming: true,
        image: "Cards/4080009/Card_4080009_2_b.png",
    },
    {
        cardId: 4060009,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【笑顔で空を灯して】",
        Blooming: true,
        image: "Cards/4060009/Card_4060009_2_b.png",
    },
    {
        cardId: 4160011,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【バレット・タイム】",
        Blooming: false,
        image: "Cards/4160011/Card_4160011_1_b.png",
    },
    {
        cardId: 3060004,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【シスター・シスター】",
        Blooming: true,
        image: "Cards/3060004/Card_3060004_2_b.png",
    },
    {
        cardId: 3150007,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【エイジ・オブ・ディスカバリー】",
        Blooming: false,
        image: "Cards/3150007/Card_3150007_1_b.png",
    },
    {
        cardId: 3050004,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【永久機関オルタネーター】",
        Blooming: false,
        image: "Cards/3050004/Card_3050004_1_b.png",
    },
    {
        cardId: 3090015,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【ウインナワルツ】",
        Blooming: true,
        image: "Cards/3090015/Card_3090015_2_b.png",
    },
    {
        cardId: 3020012,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【キャンパス・エッヂ】",
        Blooming: true,
        image: "Cards/3020012/Card_3020012_2_b.png",
    },
    {
        cardId: 4130005,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【Forever Friends】",
        Blooming: false,
        image: "Cards/4130005/Card_4130005_1_b.png",
    },
    {
        cardId: 4110005,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【Forever Friends】",
        Blooming: false,
        image: "Cards/4110005/Card_4110005_1_b.png",
    },
    {
        cardId: 4080014,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【harvest ＆ pup】",
        Blooming: false,
        image: "Cards/4080014/Card_4080014_1_b.png",
    },
    {
        cardId: 3160013,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【オー・ド・ヴィー】",
        Blooming: true,
        image: "Cards/3160013/Card_3160013_2_b.png",
    },
    {
        cardId: 4090016,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【何度も言わせて】",
        Blooming: false,
        image: "Cards/4090016/Card_4090016_1_b.png",
    },
    {
        cardId: 4090005,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【Forever Friends】",
        Blooming: false,
        image: "Cards/4090005/Card_4090005_1_b.png",
    },
    {
        cardId: 4030005,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【Forever Friends】",
        Blooming: false,
        image: "Cards/4030005/Card_4030005_1_b.png",
    },
    {
        cardId: 3070010,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【コネクト】",
        Blooming: true,
        image: "Cards/3070010/Card_3070010_2_b.png",
    },
    {
        cardId: 4130012,
        heroineId: 13,
        heroine: "丸山利恵",
        alias: "【冷酷なる悪魔のエクスキューション】",
        Blooming: true,
        image: "Cards/4130012/Card_4130012_2_b.png",
    },
    {
        cardId: 3010006,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【クロスロード・サインポスト】",
        Blooming: true,
        image: "Cards/3010006/Card_3010006_2_b.png",
    },
    {
        cardId: 3070014,
        heroineId: 7,
        heroine: "恵庭あいり",
        alias: "【スウィート・ワン】",
        Blooming: true,
        image: "Cards/3070014/Card_3070014_2_b.png",
    },
    {
        cardId: 3030015,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【はんにんはヤツ】",
        Blooming: false,
        image: "Cards/3030015/Card_3030015_1_b.png",
    },
    {
        cardId: 4080015,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【パッシング・トーキョー】",
        Blooming: false,
        image: "Cards/4080015/Card_4080015_1_b.png",
    },
    {
        cardId: 3010007,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【秋晴れ乙女】",
        Blooming: false,
        image: "Cards/3010007/Card_3010007_1_b.png",
    },
    {
        cardId: 4080012,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【ユー・ガット・エール】",
        Blooming: false,
        image: "Cards/4080012/Card_4080012_1_b.png",
    },
    {
        cardId: 4110005,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【Forever Friends】",
        Blooming: true,
        image: "Cards/4110005/Card_4110005_2_b.png",
    },
    {
        cardId: 4160008,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【Only two twin primes】",
        Blooming: true,
        image: "Cards/4160008/Card_4160008_2_b.png",
    },
    {
        cardId: 4120013,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【私をビーチに連れてって】",
        Blooming: true,
        image: "Cards/4120013/Card_4120013_2_b.png",
    },
    {
        cardId: 4040013,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【fun! fun! fun!】",
        Blooming: true,
        image: "Cards/4040013/Card_4040013_2_b.png",
    },
    {
        cardId: 3090004,
        heroineId: 9,
        heroine: "夜峰美晴",
        alias: "【フェアリー・オン・ステージ】",
        Blooming: false,
        image: "Cards/3090004/Card_3090004_1_b.png",
    },
    {
        cardId: 4150010,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【ビン詰めの花畑】",
        Blooming: true,
        image: "Cards/4150010/Card_4150010_2_b.png",
    },
    {
        cardId: 4110010,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【孤独ノスヽメ】",
        Blooming: false,
        image: "Cards/4110010/Card_4110010_1_b.png",
    },
    {
        cardId: 3100012,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【penguin avenue】",
        Blooming: false,
        image: "Cards/3100012/Card_3100012_1_b.png",
    },
    {
        cardId: 4060010,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【今日は明日の思い出】",
        Blooming: false,
        image: "Cards/4060010/Card_4060010_1_b.png",
    },
    {
        cardId: 4060012,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【部屋の中の晴々】",
        Blooming: true,
        image: "Cards/4060012/Card_4060012_2_b.png",
    },
    {
        cardId: 4060013,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【オーバー・ザ・シー】",
        Blooming: false,
        image: "Cards/4060013/Card_4060013_1_b.png",
    },
    {
        cardId: 4040013,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【fun! fun! fun!】",
        Blooming: false,
        image: "Cards/4040013/Card_4040013_1_b.png",
    },
    {
        cardId: 4080007,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【What a girl wants】",
        Blooming: false,
        image: "Cards/4080007/Card_4080007_1_b.png",
    },
    {
        cardId: 3050006,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【唇よ、熱くキミを語れ！】",
        Blooming: true,
        image: "Cards/3050006/Card_3050006_2_b.png",
    },
    {
        cardId: 3140007,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【君、死にたもうことなかれ】",
        Blooming: true,
        image: "Cards/3140007/Card_3140007_2_b.png",
    },
    {
        cardId: 4100013,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【above the promise】",
        Blooming: true,
        image: "Cards/4100013/Card_4100013_2_b.png",
    },
    {
        cardId: 4160010,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【リンケージ・マイナー】",
        Blooming: true,
        image: "Cards/4160010/Card_4160010_2_b.png",
    },
    {
        cardId: 3120008,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【縁起色レイクフェア】",
        Blooming: true,
        image: "Cards/3120008/Card_3120008_2_b.png",
    },
    {
        cardId: 3150004,
        heroineId: 15,
        heroine: "明神凛音",
        alias: "【走れ凛音】",
        Blooming: true,
        image: "Cards/3150004/Card_3150004_2_b.png",
    },
    {
        cardId: 4120009,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【パウダーシュガーの降る頃に】",
        Blooming: false,
        image: "Cards/4120009/Card_4120009_1_b.png",
    },
    {
        cardId: 4050009,
        heroineId: 5,
        heroine: "天童悠希",
        alias: "【疾走れ！自転の勇者ママチャリオン】",
        Blooming: false,
        image: "Cards/4050009/Card_4050009_1_b.png",
    },
    {
        cardId: 4100011,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【End of twilight】",
        Blooming: true,
        image: "Cards/4100011/Card_4100011_2_b.png",
    },
    {
        cardId: 4020011,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【ベイビー・クロケット】",
        Blooming: false,
        image: "Cards/4020011/Card_4020011_1_b.png",
    },
    {
        cardId: 3080016,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【Terms of Fortune】",
        Blooming: true,
        image: "Cards/3080016/Card_3080016_2_b.png",
    },
    {
        cardId: 4060005,
        heroineId: 6,
        heroine: "赤川千紗",
        alias: "【Forever Friends】",
        Blooming: true,
        image: "Cards/4060005/Card_4060005_2_b.png",
    },
    {
        cardId: 4010013,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【廻る日の１ページ】",
        Blooming: true,
        image: "Cards/4010013/Card_4010013_2_b.png",
    },
    {
        cardId: 4100007,
        heroineId: 10,
        heroine: "神室絢",
        alias: "【in other words】",
        Blooming: false,
        image: "Cards/4100007/Card_4100007_1_b.png",
    },
    {
        cardId: 4110014,
        heroineId: 11,
        heroine: "宮路まほろ",
        alias: "【DELIGHT & DAYLIGHT】",
        Blooming: false,
        image: "Cards/4110014/Card_4110014_1_b.png",
    },
    {
        cardId: 4010009,
        heroineId: 1,
        heroine: "六石陽菜",
        alias: "【束の間のロンググッドバイ】",
        Blooming: false,
        image: "Cards/4010009/Card_4010009_1_b.png",
    },
    {
        cardId: 4160005,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【Forever Friends】",
        Blooming: false,
        image: "Cards/4160005/Card_4160005_1_b.png",
    },
    {
        cardId: 4120012,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【オフショアの乙女】",
        Blooming: true,
        image: "Cards/4120012/Card_4120012_2_b.png",
    },
    {
        cardId: 4040012,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【女王に捧げる薬指】",
        Blooming: false,
        image: "Cards/4040012/Card_4040012_1_b.png",
    },
    {
        cardId: 3020009,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【シンケン・トライブ】",
        Blooming: false,
        image: "Cards/3020009/Card_3020009_1_b.png",
    },
    {
        cardId: 4120013,
        heroineId: 12,
        heroine: "日名倉莉子",
        alias: "【私をビーチに連れてって】",
        Blooming: false,
        image: "Cards/4120013/Card_4120013_1_b.png",
    },
    {
        cardId: 4040005,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【Forever Friends】",
        Blooming: false,
        image: "Cards/4040005/Card_4040005_1_b.png",
    },
    {
        cardId: 4030010,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【ぬれねこにひき】",
        Blooming: true,
        image: "Cards/4030010/Card_4030010_2_b.png",
    },
    {
        cardId: 3030009,
        heroineId: 3,
        heroine: "鹿野志穂",
        alias: "【かぜのまにまに】",
        Blooming: true,
        image: "Cards/3030009/Card_3030009_2_b.png",
    },
    {
        cardId: 4080007,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【What a girl wants】",
        Blooming: true,
        image: "Cards/4080007/Card_4080007_2_b.png",
    },
    {
        cardId: 3080018,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【The Back-up Plan】",
        Blooming: false,
        image: "Cards/3080018/Card_3080018_1_b.png",
    },
    {
        cardId: 3140014,
        heroineId: 14,
        heroine: "宇津木聡里",
        alias: "【薔薇と黙示録をあなたに】",
        Blooming: false,
        image: "Cards/3140014/Card_3140014_1_b.png",
    },
    {
        cardId: 3080008,
        heroineId: 8,
        heroine: "九条柚葉",
        alias: "【ルーキーアイスガール】",
        Blooming: false,
        image: "Cards/3080008/Card_3080008_1_b.png",
    },
    {
        cardId: 4020014,
        heroineId: 2,
        heroine: "鷹取舞花",
        alias: "【ライトマイファイア】",
        Blooming: true,
        image: "Cards/4020014/Card_4020014_2_b.png",
    },
    {
        cardId: 3160006,
        heroineId: 16,
        heroine: "遠見鳴",
        alias: "【ダーク・ルーム】",
        Blooming: true,
        image: "Cards/3160006/Card_3160006_2_b.png",
    },
    {
        cardId: 3040011,
        heroineId: 4,
        heroine: "月居ほのか",
        alias: "【ウィッシュムーン】",
        Blooming: true,
        image: "Cards/3040011/Card_3040011_2_b.png",
    }
];
